<script setup>
import { ref, computed} from 'vue';

//properties set by parent
/* const props = defineProps({
	modelValue: {
		type: Number,
		required: true,
	}
}) */

//componenet methods exposed to parent
defineExpose({
    initPaging
});

//events raised by component
const emit = defineEmits(['updatePage']);

//reactive field proxies
const currentPage = ref(1); //ref(props.modelValue);   //props.chartSettings.currentPage
const pageBlockStart = ref(1);
const totalPages = ref(0)


/* const pageSize = 10;
const totalItems = ref(0);
const totalPages = ref(1);
const sortColumn = ref(null);
const sortDirection = ref('asc'); // or 'desc'
const currentData = ref([]); */

//local variables
const pageBlockSize = 3;


//const lastPage = computed(() => Math.ceil(data.value.length / pageSize));

//watch(currentPage, alert('cur pg chg'));

//Methods
function initPaging(blockStart, totPages) {
	currentPage.value = pageBlockStart.value = blockStart
	totalPages.value = totPages
}

const visiblePages = computed(() => {
  const pages = [];
  for (let i = 0; i < pageBlockSize; i++) {
    const page = pageBlockStart.value + i;
    if (page <= totalPages.value) pages.push(page);
  }
  return pages;
});

function goToPage(page) {
  if (page < 1 || page > totalPages.value) return;

  currentPage.value = page;

    // Jump to last page
	if (page >= totalPages.value) {
		pageBlockStart.value = totalPages.value - pageBlockSize + 1;
	}
	// Jump blocks forward
	else if (page > pageBlockStart.value + pageBlockSize - 1 && page + 1 < totalPages.value) {
		pageBlockStart.value += pageBlockSize;
	}
	// Jump blocks backward
	else if (page < pageBlockStart.value) {
			pageBlockStart.value = Math.max(1, page - (pageBlockSize - 1));
	}
	// Reset to first block
	if (page < pageBlockSize) {
		pageBlockStart.value = 1;
	}

  	emit('updatePage', currentPage.value);
}

</script>
<template>
	<div class="paging-container">
		<button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
			Previous
		</button>

		<button class="btn-page"
			v-if="pageBlockStart > 1"
			@click="goToPage(1)"
			:class="{ active: currentPage === 1 }">
			1
		</button>
		<!--
		<span v-if="pageBlockStart > 2">…</span>
	-->
		<button  class="btn-page"
			v-for="page in visiblePages"
			:key="page"
			:class="{ active: page === currentPage }"
			@click="goToPage(page)">
			{{ page }}
		</button>

		<!--
		<span v-if="pageBlockStart + pageBlockSize - 1 < totalPages">…</span>
		-->
		<button  class="btn-page"
			v-if="!visiblePages.includes(totalPages)"
			@click="goToPage(totalPages)"
			:class="{ active: currentPage === totalPages }">
			{{ totalPages }}
		</button>

		<button  class="btn-page" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
			Next
		</button>
	</div>
</template>



<style scoped>
.paging-container {
	display: flex;
	justify-content: end;
    column-gap: 0;
    align-items: baseline;
	flex-wrap: nowrap;
}

/* .pagination {
  margin-top: 20px;
  display: flex;
  gap: 0;
  flex-wrap: wrap;
} */

.paging-container span {
  padding: 5px 10px;
  line-height: 2;
}

button {
	display: flex;
	height: 40px;
	min-width: 40px;
	padding: var(--spacing-md, 8px);
	justify-content: center;
	align-items: center;
	gap: var(--spacing-md, 8px);	
	border-radius: var(--spacing-sm, 4px) 0px 0px var(--spacing-sm, 4px);
	border: 1px solid var(--border-color-input-Border, #A9B7C7);
	background: var(--surface-color-Tertiary, #FAFAFA);
}

button:disabled {
	cursor: default;
	color: #000;
	text-decoration: none;
}

button.active {
	border-top: 1px solid var(--borders-divider-Active, #064291);
	border-right: 1px solid var(--borders-divider-Active, #064291);
	border-bottom: 1px solid var(--borders-divider-Active, #064291);
	background: var(--surface-brand-Blue, #064291);  
	color: var(--brand-color-White, #FFF);
}

.btn-page {
	color: var(--brand-color-MedGrey);

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 16px);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 24px); /* 150% */
}

.tbl-header-container {
	container-type: inline-size;
	min-width: 0;      /* Crucial for row layouts to allow shrinking */
}
@container (max-width: 30.625rem) {
	.paging-container {
		justify-content:start;
	}
}

</style>